import * as React from 'react';
import type { ICustomModalProps } from '../types';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import styles from './custom-modal.module.sass';
import close from './close.svg';


export interface CustomModalProps extends ICustomModalProps {
    handleCloseModal: any;
}

export const CustomModal = (props: CustomModalProps) => {

    const { show, title, body, canClose, closeButtonText, action, handleCloseModal, hideFooter, ...rest } = props;

    return (
        <Modal fullscreen={'sm-down'} show={show} size="lg" aria-labelledby="contained-modal-title-vcenter"
               centered {...rest} className={styles.customModal} data-testid="modal" animation={false}>
            <Modal.Header>
                {canClose && <Button onClick={handleCloseModal} variant="link" className={styles.closeButton}>
                    <img src={close}
                         alt="X" />
                </Button>}

                <Modal.Title id="contained-modal-title-vcenter">
                    {title}
                </Modal.Title>
                {action && <div className={styles.headerAction}>{action}</div>}
            </Modal.Header>
            <Modal.Body>
                {body}
            </Modal.Body>
            <Modal.Footer>
                <></>
                {!hideFooter &&
                    <>
                        {
                            canClose
                                ? <Button onClick={handleCloseModal} variant="link" data-testid="btnModalCancelClose"
                                          className={styles.closeButton}>
                                    {closeButtonText ? closeButtonText : action ? 'Cancel' : 'Close'}
                                </Button>
                                : <span className={'mt-5'} />
                        }
                        {action && <div className={styles.modalAction}>{action}</div>}
                    </>
                }
            </Modal.Footer>
        </Modal>
    );
};
